import * as React from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  IconButton,
  Tooltip,
  CircularProgress,
} from "@mui/material";
import { useNotify, useRefresh } from "react-admin";

export const ConfirmActionButton = ({
  label,
  icon,
  color = "primary",
  variant = "contained",
  size = "small",
  iconOnly = false,
  confirmTitle = "Confirmer l'action",
  confirmText = "Êtes-vous sûr ?",
  successMessage = "Action effectuée",
  errorMessage = "Erreur",
  onConfirm,
  disabled = false,
  refreshOnSuccess = true,
}) => {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const notify = useNotify();
  const refresh = useRefresh();

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm();
      notify(successMessage, { type: "success" });
      if (refreshOnSuccess) refresh();
      setOpen(false);
    } catch (e) {
      notify(`${errorMessage} : ${e?.message || e}`, { type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {iconOnly ? (
        <Tooltip title={label}>
          <IconButton
            size={size}
            color={color}
            onClick={() => setOpen(true)}
            disabled={disabled}
          >
            {icon}
          </IconButton>
        </Tooltip>
      ) : (
        <Button
          size={size}
          variant={variant}
          color={color}
          onClick={() => setOpen(true)}
          startIcon={icon}
          disabled={disabled}
        >
          {label}
        </Button>
      )}
      <Dialog open={open} onClose={() => !loading && setOpen(false)}>
        <DialogTitle>{confirmTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText>{confirmText}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} disabled={loading}>
            Annuler
          </Button>
          <Button
            onClick={handleConfirm}
            color={color}
            variant="contained"
            disabled={loading}
          >
            {loading ? <CircularProgress size={20} /> : "Confirmer"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ConfirmActionButton;
